import React from 'react';
import { Spinner } from './Spinner';

const PageLoadingSpinner = () => {
  return (
    <div className="container text-center">
      <h4 className="mt-5 mb-2">Loading</h4>
      <Spinner show={true} size="fa-5x" />
    </div>
  );
};

export { PageLoadingSpinner };
